import React from 'react';
import { Stack } from '@mui/material';

import { LeafStateProvider } from 'context/state/leaf';

import { CameraTileContainer } from 'components/camera/CameraTileContainer';
import { NoCamera } from 'components/error/NoCamera';
import { AppDeviceLeaf } from 'types/common/leaf';

import styles from './focusedView.module.scss';

interface FocusedViewProps {
  leafId: AppDeviceLeaf['id'];
  deviceLeaves: Array<AppDeviceLeaf>;
}

const DevicesPreviewList = ({ deviceLeaves, leafId }: DevicesPreviewListProps) =>
  deviceLeaves?.map((device) => (
    <LeafStateProvider key={device.id} leafId={device.id}>
      <CameraTileContainer
        id={`${device.id}-ctc-preview`}
        className={device.id === leafId ? styles.active : ''}
        cameraTileType="preview"
      />
    </LeafStateProvider>
  ));

export interface DevicesPreviewListProps {
  deviceLeaves: Array<AppDeviceLeaf>;
  leafId: AppDeviceLeaf['id'];
}

export const FocusedView = ({ leafId, deviceLeaves }: FocusedViewProps) => (
  <div className={styles.focusedView}>
    <Stack direction="column" className={styles.sidebar}>
      <DevicesPreviewList deviceLeaves={deviceLeaves} leafId={leafId} />
    </Stack>
    <div className={styles.content}>
      <LeafStateProvider key={leafId} leafId={leafId} NoLeafComponent={NoCamera}>
        <CameraTileContainer id={`${leafId}-ctc-normal`} isFocusedView />
      </LeafStateProvider>
    </div>
  </div>
);
